var invr = setInterval(function () {
  $(".mobile_drw.d-block.d-md-none.open_mobile .radio_container input").click(
    function () {
      $(this).parents(".radio_container").addClass("show_click");
      $(this).parents(".radio_container").siblings().removeClass("show_click");
      var val = $(this).val();
      console.log(val);
      $(
        ".mobile_drw.d-block.d-md-none.open_mobile .text-line-one p.textline1"
      ).css("font-family", val);
      $(
        ".mobile_drw.d-block.d-md-none.open_mobile .text-line-two p.textline2"
      ).css("font-family", val);
    }
  );
  // clearInterval(invr);
}, 5000);

$('input[type="text"]').on("keydown, keyup", function () {
  var texInputValue = $(
    ".mobile_drw.d-block.d-md-none.open_mobile .engraving-middle-part.sm-mt-4 .form__group.mb-3 input#product-properties-name"
  ).val();
  $(
    ".mobile_drw.d-block.d-md-none.open_mobile .text-line-one p.textline1"
  ).html(texInputValue);
});
$('input[type="text"]').on("keydown, keyup", function () {
  var texInputValue = $(
    ".mobile_drw.d-block.d-md-none.open_mobile .form__group input#product-properties-number"
  ).val();
  $(
    ".mobile_drw.d-block.d-md-none.open_mobile .text-line-two p.textline2"
  ).html(texInputValue);
});

$(
  ".mobile_drw.d-block.d-md-none .engraving-top-part.d-block.d-md-none div#mobile_close"
).click(function () {
  event.preventDefault();
  $(".mobile_drw.d-block.d-md-none").removeClass("open_mobile");
  console.log("done");
});

$("div#add_submit").click(function () {
  event.preventDefault();
  var val_1 = $(".radio_container.show_click input").val();
  var name_val = $(
    ".mobile_drw.d-block.d-md-none.open_mobile .form__group.mb-3 input#product-properties-name"
  ).val();
  var phone_mb = $(
    ".mobile_drw.d-block.d-md-none.open_mobile .form__group input#product-properties-number"
  ).val();
  console.log(phone_mb);
  $(".mobile_drw.d-block.d-md-none").removeClass("open_mobile");
  $(".last_div").show();
  $(".last_div .full--width.engraving--added.mb-3").show();
  $(
    ".last_div ul.faq__accordion .engraving--details.coll-details-part p#fontName .text-co"
  ).html(val_1);
  $(
    ".last_div ul.faq__accordion .engraving--details.coll-details-part p#Name .text-co"
  ).html(name_val);
  $(
    ".last_div ul.faq__accordion .engraving--details.coll-details-part p#phone .text-co"
  ).html(phone_mb);
  $(".custom_btn").hide();
  $(".last_div .full--width.engraving--added.mb-3").addClass("add_products");
});

$(".mobile_add").click(function () {
  var sz = $(".var_text.price_active").text();
  var name = $(".coll-meta.bundle_active").attr("data-match");
  var vid = $('.var_text[proti="' + name + '"][size="' + sz + '"]').attr(
    "var-id"
  );
  var fontname = $(
    ".last_div .full--width.engraving--added.mb-3 .engraving--details.coll-details-part p#fontName span.text-co"
  ).text();
  var name_q = $(
    ".last_div .full--width.engraving--added.mb-3 .engraving--details.coll-details-part p#Name span.text-co"
  ).text();
  var phone = $(
    ".last_div .full--width.engraving--added.mb-3 .engraving--details.coll-details-part p#phone span.text-co"
  ).text();
  var pro_id = $(this).attr("coll_nex");
  console.log(pro_id);
  var items = [];
  items.push({
    id: vid,
    quantity: 1,
    properties: { font: fontname, Name: name_q, PhoneNumber: phone },
  });
  if (
    $(".last_div .full--width.engraving--added.mb-3").hasClass("add_products")
  ) {
    items.push({ id: pro_id, quantity: 1, properties: { font: fontname, Name: name_q, PhoneNumber: phone } });
  } else {
  }
  console.log(vid);
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: { items: items },
    dataType: "json",
    success: function () {
      console.log("sucess");
      cart.getCart();
    },
    error: function () {
      console.log("error");
    },
  });
});

// $('.button_coll .product__popup__link').click(function(){
//    $('[data-product-form] .product__popup__link').click()
// });

// $("body.no-custom .button_coll .product__popup__link").click(function () {
//   $("[data-product-form] .product__popup__link").click();
// });
